export default {
  navigate: 'ytx:navigate',
  action: 'ytx:actionInfo',
  share: 'ytx:share'
}



// WEBPACK FOOTER //
// ./src/constants/bridge-event.js